import { render } from "./BitacoraTra.vue?vue&type=template&id=498d72f4&scoped=true"
import script from "./BitacoraTra.vue?vue&type=script&lang=js"
export * from "./BitacoraTra.vue?vue&type=script&lang=js"

import "./BitacoraTra.vue?vue&type=style&index=0&id=498d72f4&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\allikamay\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-498d72f4"]])

export default __exports__